import { render, staticRenderFns } from "./storedcard.vue?vue&type=template&id=282661a4&scoped=true&"
import script from "./storedcard.vue?vue&type=script&lang=js&"
export * from "./storedcard.vue?vue&type=script&lang=js&"
import style0 from "./storedcard.vue?vue&type=style&index=0&id=282661a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282661a4",
  null
  
)

export default component.exports